import styled from "@emotion/styled";

export const StyledFooter = styled.footer({
    display: "flex",
    justifyContent: "space-between",
});
